import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConvertOrderStatusToNumberPipe } from './convert-order-status-to-number.pipe';
import { ConvertAmountFormatPipe } from './convert-amount-format.pipe';
import { ConvertBigintToNumberPipe } from './convert-bigint-to-number.pipe';
import { ConvertCentsPipe } from './convert-cents.pipe';
import { ConvertPoSkuTableReadableTypePipe } from './convert-po-sku-table-readable-type.pipe';
import { DisplayPipesModule } from '../display/display-pipes.module';
import { CapitalizeFirstLetterPipe } from './capitalizeFirstLetter.pipe';
import { CalculateContainerLoadTotalPipe } from './calculate-container-load-total.pipe';
import { ConvertNumberPipe } from './convert-number.pipe';
import { ConvertMeterToMilePipe } from './convert-meter-to-mile.pipe';
import { ConvertSecToMinPipe } from './convert-sec-to-min.pipe';
import { ConvertSecToHrsPipe } from './convert-sec-to-hrs.pipe';
import { ConvertMeterToKmPipe } from './convert-meter-to-km.pipe';



@NgModule({
  declarations: [
    ConvertOrderStatusToNumberPipe,
    ConvertAmountFormatPipe,
    ConvertBigintToNumberPipe,
    ConvertCentsPipe,
    ConvertPoSkuTableReadableTypePipe,
    CapitalizeFirstLetterPipe,
    CalculateContainerLoadTotalPipe,
    ConvertNumberPipe,
    CapitalizeFirstLetterPipe,
    ConvertMeterToMilePipe,
    ConvertMeterToKmPipe,
    ConvertSecToMinPipe,
    ConvertSecToHrsPipe,
  ],
  imports: [
    CommonModule,
    DisplayPipesModule
  ],
  exports:[
    ConvertOrderStatusToNumberPipe,
    ConvertAmountFormatPipe,
    ConvertBigintToNumberPipe,
    ConvertCentsPipe,
    ConvertPoSkuTableReadableTypePipe,
    CapitalizeFirstLetterPipe,
    CalculateContainerLoadTotalPipe,
    ConvertNumberPipe,
    CapitalizeFirstLetterPipe,
    ConvertMeterToMilePipe,
    ConvertMeterToKmPipe,
    ConvertSecToMinPipe,
    ConvertSecToHrsPipe
  ]
})
export class ConvertModule { }
